import { render, staticRenderFns } from "./ErrorMessagePopup.vue?vue&type=template&id=649ffd5b&scoped=true"
import script from "./ErrorMessagePopup.vue?vue&type=script&lang=js"
export * from "./ErrorMessagePopup.vue?vue&type=script&lang=js"
import style0 from "./ErrorMessagePopup.vue?vue&type=style&index=0&id=649ffd5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ffd5b",
  null
  
)

export default component.exports